// import { logout } from 'actions/auth.js';
import {
  LOGOUT,
  AUTH,
  FETCH_USERS,
  START_LOADING,
  END_LOADING,
  USER_LOGIN_FAIL,
  AGENT_CREATION_FAIL,
  CREATE_USER,
  DELETE_USER,
  UPDATE_USER,
  FETCH_USER_SINGLE,
  USER_CREATED,
  FETCH_CLIENT_BY_SEARCH,
} from '../constants/actionTypes.js';
import { encryptData } from '../utilities/encryption.js';
import { clear as clearImpersonation } from '../utilities/impersonation.js';

const initialState = {
  authorizedUsers: [],
  agent: null,
  isLoading: false,
  isAuthenticated: false,
  error: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case START_LOADING:
      return { ...state, isLoading: true, error: null };
    case END_LOADING:
      return { ...state, isLoading: false };
    case USER_LOGIN_FAIL:
    case AGENT_CREATION_FAIL:
      return { ...state, isLoading: false, error: action.payload };
    case CREATE_USER:
      return {
        ...state,
        authorizedUsers: [...state.authorizedUsers, action.payload],
        error: null
      };
    case USER_CREATED:
      return { ...state, userCreated: true, isLoading: false, error: null };
    case DELETE_USER:
      return {
        ...state,
        authorizedUsers: state.authorizedUsers.filter((user) => user._id !== action.payload),
        isLoading: false,
        error: null
      };
    case UPDATE_USER: {
      // GUARD: the update endpoint replies { message } (no _id). The old map
      // compared undefined === undefined and replaced EVERY row with the
      // message object — emptying the staff directory until a hard refresh.
      // Only patch the list when we actually received an updated user doc.
      const updated = action.payload;
      if (!updated || !updated._id) {
        return { ...state, isLoading: false, error: null };
      }
      return {
        ...state,
        authorizedUsers: state.authorizedUsers.map((agent) =>
          (agent?._id || agent?.user?._id) === updated._id
            ? agent?.user
              ? { ...agent, user: { ...agent.user, ...updated } }
              : updated
            : agent
        ),
        isLoading: false,
        error: null
      };
    }
    case FETCH_USERS:
    case FETCH_CLIENT_BY_SEARCH:
      return {
        ...state,
        authorizedUsers: action.payload.data,
        isLoading: false,
        error: null
      };
    case FETCH_USER_SINGLE:
      return { ...state, agent: action.payload.agent, isLoading: false, error: null };
    case LOGOUT:
      localStorage.removeItem('profile');
      localStorage.removeItem('token');
      localStorage.removeItem('refreshToken');
      // A sign-out while signed in as a vendor leaves neither the stashed
      // admin session nor the banner's facts behind.
      clearImpersonation();
      return { ...initialState };
    case AUTH:
      const encryptedProfile = encryptData({ ...action?.data });
      localStorage.setItem('profile', encryptedProfile);
      localStorage.setItem('token', action?.data?.token);
      // Persist refresh token if provided (phone OTP logins)
      if (action?.data?.refreshToken) {
        localStorage.setItem('refreshToken', action.data.refreshToken);
      } else {
        // Never let a previous account's refresh credential survive a new
        // login flow (3PL sessions currently issue access tokens only).
        localStorage.removeItem('refreshToken');
      }
      return {
        ...state,
        agent: action?.data,
        isLoading: false,
        isAuthenticated: true,
        error: null
      };
    default:
      return state;
  }
};
